'use client';

import { scoreboardService } from '@/services/scoreboard.service';
import { SportMatchModel } from '@nf/types/odds';

export const MatchCricket = ({ match, home, away }: { match: SportMatchModel, home: string, away: string }) => {
	const homeScoreList = scoreboardService.getMatchCricketScore(match, 'home');
	const awayScoreList = scoreboardService.getMatchCricketScore(match, 'away');
	return (
		<div className="single-topbar__match">
			<div className="single-topbar__row">
				<span className="team-name">
					{home}
				</span>
				{
					homeScoreList.map((item, index) => {
						return (
							<span className={item.isPlay ? 'team-score' : 'team-score team-score--disabled'} key={index}>
								{item.text}
							</span>
						)
					})
				}
			</div>
			<div className="single-topbar__row">
				<span className="team-name">
					{away}
				</span>
				{
					awayScoreList.map((item, index) => {
						return (
							<span className={item.isPlay ? 'team-score' : 'team-score team-score--disabled'} key={index}>
								{item.text}
							</span>
						)
					})
				}
			</div>
		</div>
	)
}